module.exports = __webpack_public_path__ + "img/default_main.f1862218.png";